/**
 * Register Professor Review Wizard Alpine Component
 */
import professorReviewWizard from './wizard.js';

document.addEventListener('livewire:init', () => {
    window.Alpine.data('professorReviewWizard', professorReviewWizard);
});



















